import {
  extend,
  localize
} from "vee-validate";
import ptBR from "vee-validate/dist/locale/pt_BR.json";
import { email, required, max, min, confirmed } from "vee-validate/dist/rules";
import { cpf } from "cpf-cnpj-validator";
import { isValidCnpj } from "@/utils/document";

localize("pt_BR", ptBR);

extend('email', email);
extend('required', required);
extend('max', max);
extend('min', min);
extend('confirmed', confirmed);

// Validações de documento. Por padrão o vee-validate roda em modo "aggressive",
// validando a cada caractere digitado.
extend('cnpj', {
  validate: (value) => isValidCnpj(value),
  message: 'Informe um CNPJ válido.'
});

extend('cpf', {
  validate: (value) => cpf.isValid(value),
  message: 'Informe um CPF válido.'
});

extend('cpf_cnpj', {
  validate: (value) => cpf.isValid(value) || isValidCnpj(value),
  message: 'Informe um CPF ou CNPJ válido.'
});
